import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {logout, isLoggedIn} from '../../../utils/auth';

import * as authActionCreators from '../../../actions/auth';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, authActionCreators, userActionCreators);

import {AccountInfoContainer} from './blocks/AccountInfo';
import {AccountWishlistContainer} from './blocks/AccountWishlist';
import {AccountOrdersContainer} from './blocks/AccountOrders';
import {AccountAppointmentContainer} from './blocks/AccountAppointment';

import RhinoSelect from '../../common/inputs/RhinoSelect';


class Account extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let tabData = [
      {
        display: 'Online Account Info',
        value: 'accountInfo'
      },
      {
        display: 'Online Wishlist',
        value: 'wishlist'
      },
      // {
      //   display: 'Open Orders',
      //   value: 'openOrders'
      // },
      {
        display: 'Online History',
        value: 'orderHistory'
      },
      {
        display: 'Request an Appointment',
        value: 'appointments'
      },
      {
        display: 'Log Out',
        value: 'logout'
      },
    ];

		this.state = {
      currentTab: 'accountInfo',
      firstName: null,
      mobileTabData: tabData,
    };

    
	}

	componentDidMount() {

    if(this.props.user.userCore === null && isLoggedIn()) {
      this.props.userGetUser()
      .then((resp) => {        
        this.props.userSaveCore(resp);
        this.setFirstName(resp.firstname);
        this.props.userGetOrders(resp.id)
        .then((orderResp) => {
          this.props.userSaveOrders(JSON.parse(orderResp).orders);
        });
      });
    } else {
      this.props.userGetOrders(this.props.user.userCore.id)
      .then((resp) => {
        console.log(JSON.parse(resp));
        this.props.userSaveOrders(JSON.parse(resp).orders);
      });
    }

    if(this.props.user.userProfile === null && isLoggedIn()) {
      this.props.userGetProfile()
      .then((resp) => {        
        this.props.userSaveProfile(resp);


        // if(resp.customer.access_orders_history || resp.customer.access_orders_open) {

        //   console.log('get userGetExternalOrders');

        //   this.props.userGetExternalOrders()
        //   .then((orderResp) => {
        //     console.log(orderResp.orders);
        //     this.props.userSaveExternalOrders(orderResp.orders);
        //   });
        // }

      });
    } else if(this.props.user.userProfile && (this.props.user.userProfile.customer.access_orders_history || this.props.user.userProfile.customer.access_orders_open)) {

      // this.props.userGetExternalOrders()
      // .then((orderResp) => {
      //   console.log(orderResp.orders);
      //   this.props.userSaveExternalOrders(orderResp.orders);
      // });
    }




    if(this.props.user.wishlists === null && isLoggedIn()) {
      this.props.userGetWishlists()
      .then((respData) => {
        // console.log(this.props);
        this.props.userSaveWishlists(respData.wishlists);
      });
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  selectTab(tab) {
    if(tab != this.state.currentTab) {
      this.setState({ currentTab: tab });
    }
  }

  selectTabFromDropdown(evt) {
    let tab = evt.target.value;

    if(tab == 'logout') {
      this.logoutUser();
    } else if(tab != this.state.currentTab) {
      this.setState({ currentTab: tab });
    }
  }

  logoutUser() {
    logout();
    this.props.authClear();
    window.location.href= '/';
  }

  setFirstName(name) {
    this.setState({ firstName: name });
  }

  renderAccountBody() {
    if(this.state.currentTab == 'accountInfo') {
      return <AccountInfoContainer setFirstNameMethod={(val) => this.setFirstName(val)} />;
    } else if(this.state.currentTab == 'wishlist') {
      return <AccountWishlistContainer />;
    } else if(this.state.currentTab == 'openOrders') {
      return <AccountOrdersContainer openOrders={true} />;
    } else if(this.state.currentTab == 'orderHistory') {
      return <AccountOrdersContainer showAll={true} />;
    } else if(this.state.currentTab == 'appointments') {
      return <AccountAppointmentContainer />;
    } else {
      return <AccountInfoContainer setFirstNameMethod={(val) => this.setFirstName(val)} />;
    }
  }

	render() {
		return <div className='Account'>
			<div className='accountMenu'>
        <div className='accountMenuWrapper'>
          <div className='accountMenuHeader'>
            {this.state.firstName === null || this.state.firstName === '' ?
              <div className='accountMenuTitle'>Hello!</div> :
              <div className='accountMenuTitle'>Hello, {this.state.firstName}!</div>
            }
            <div className='accountMenuSubtitle'>Welcome to your online account dashboard</div>
          </div>
          <div className='accountItemWrapper'>
            <div 
              className={this.state.currentTab == 'accountInfo' ? 'accountItem selected' : 'accountItem'}
              onClick={() => this.selectTab('accountInfo')}>
              <div className={'accountLabel accountInfoItem'}>Online Account Info</div>
            </div>
            <div 
              className={this.state.currentTab == 'wishlist' ? 'accountItem selected' : 'accountItem'}
              onClick={() => this.selectTab('wishlist')}>
              <div className={'accountLabel wishlistItem'}>Online Wishlist</div>
            </div>
            <div 
              className={this.state.currentTab == 'openOrders' ? 'accountItem selected' : 'accountItem'}
              onClick={() => this.selectTab('openOrders')}
              style={{display: 'none'}}>
              <div className={'accountLabel openOrdersItem'}>Open Orders</div>
            </div>
            <div 
              className={this.state.currentTab == 'orderHistory' ? 'accountItem selected' : 'accountItem'}
              onClick={() => this.selectTab('orderHistory')}>
              <div className={'accountLabel orderHistoryItem'}>Online Orders</div>
            </div>
            <div 
              className={this.state.currentTab == 'appointments' ? 'accountItem selected' : 'accountItem'}
              onClick={() => this.selectTab('appointments')}>
              <div className={'accountLabel appointmentItem'}>Request an Appointment</div>
            </div>
            <div 
              className={'accountItem'}
              onClick={::this.logoutUser}>
              <div className={'accountLabel logoutItem'}>Log Out</div>
            </div>
          </div>
          <div className='accountItemDropdownWrapper'>
            <RhinoSelect
              selectClass={'scheduleSelect'}
              options={this.state.mobileTabData}
              value={this.state.currentTab}
              changeMethod={(evt) => this.selectTabFromDropdown(evt)} />
          </div>
        </div>
      </div>
      <div className={this.state.currentTab == 'accountInfo' ? 'accountBody infoBody' : 'accountBody'}>
        <div className='accountBodyWrapper'>
          {this.renderAccountBody()}
        </div>
      </div>
		</div>;
	}
}
export default Account;

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export const AccountContainer = connect(
  mapStateToProps,
  allActionCreators
)(Account);


// WEBPACK FOOTER //
// ./src/components/views/account/Account.jsx